import { useCallback } from 'react';

export const useCopy = () => {
    const copyToClipboard = useCallback(async (text: string): Promise<boolean> => {
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(text);
                return true;
            }
            // Fallback для старых браузеров
            const tempInput = document.createElement('input');
            tempInput.value = text;
            document.body.appendChild(tempInput);
            tempInput.select();
            const success = document.execCommand('copy');
            document.body.removeChild(tempInput);
            return success;
        } catch {
            return false;
        }
    }, []);

    return { copyToClipboard };
};